module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/title_ribbon_03-29a84e0bdfb3b05aa63fd4045acde53e.png";